
const getPropertyName = (title, itemKey) => {
  if (title) return title
  return itemKey.replace(/[^a-z0-9]+/ig, ' ')
}

const parseFile = (info) => {
  const data = info;
  const window = {};
  // eslint-disable-next-line no-eval
  eval(data);
  return Object.values(window)[0];
}

export { getPropertyName, parseFile }